module.exports = __webpack_public_path__ + "static/media/HarrisonSerifPro-Regular.6d9373af.ttf";